import BttfAxios from "@features/utils/axios";
import { AxiosResponse } from "axios";

class MarketingClass {
  public getNotificationSetting(): Promise<
    AxiosResponse<{ newsletter_enabled: boolean }>
  > {
    return BttfAxios.get(
      `/api/marketing/current_investor/newsletter`,
      (resp) => resp
    );
  }

  public updateNotificationSettings(
    value: boolean
  ): Promise<AxiosResponse<{ newsletter_enabled: boolean }>> {
    return BttfAxios.patch(
      `/api/marketing/current_investor/newsletter`,
      { newsletter_enabled: value },
      (resp) => resp
    );
  }

  public updatePortfolioBuilderWaitingList(): Promise<AxiosResponse> {
    return BttfAxios.patch(
      `/api/marketing/current_investor/portfolio_builder_waiting_list`,
      {},
      (resp) => resp
    );
  }
}

const MarketingService = new MarketingClass();

export default MarketingService;
